import React from 'react';

// Helpers for displaying forfeit (loobumiskaotus) matches.
//
// A forfeit awards no pins or meeskonnapunktid, so the backend sends
// homePoints/awayPoints/homeTotal/awayTotal all as 0. The winner is identified
// by `forfeitingSide` ('HOME' | 'AWAY'). We therefore render forfeits with a
// win/loss marker instead of the numeric score.

export const isForfeitMatch = (row) => !!(row && row.isForfeit);

// Forfeit result rendered home-side-left : away-side-right. The winning side's
// '+' is always green and the forfeiting side's '-' always red, regardless of
// which team's perspective the row is viewed from.
export const forfeitScore = (row) => {
  const plus = <span style={{ color: 'green', fontWeight: 800 }}>+</span>;
  const minus = <span style={{ color: 'red', fontWeight: 800 }}>-</span>;
  const homeForfeited = row.forfeitingSide === 'HOME';
  return (
    <span style={{ fontWeight: 800 }}>
      {homeForfeited ? minus : plus} : {homeForfeited ? plus : minus}
    </span>
  );
};
